import 'expose-loader?$!jquery'
import 'expose-loader?jQuery!jquery'
import 'jquery-ujs'
import 'jquery-ui'
import 'bootstrap-sass'
import 'ekko-lightbox'
import 'jquery-validation'
import 'jquery-validation/dist/additional-methods'
import 'jQuery.print'
import 'mailcheck'
import 'whatwg-fetch'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
require('turbolinks').start()

import AddToCartForms from '../shared/add_to_cart_forms'
import './google_tag_manager'
import './forms'
import './form_validation'
import './customer'
import './analytics'
import './links/translate'
import './hotjar'
import './info_request'
import './fb-pixel'
import './layout'
import './news_articles'
import './orders'
import './package'
import './print'
import './registration'
import './category_seating_chart'
import './zopim'
import './categories'
import './countdown'
import './search'
import './carousel'
import './cookie_consent'
import './weather'
import './bynder'
import './customers'
import './links/smooth_scrolling'
import './comparison_table'
import './blogs'
import '../shared/tooltip'
import '../shared/terms_and_conditions'
import '../shared/confirmation'
//Images
import '../images'


// Load order and set session before and Vue Forms load order
import CartApi from '../shared/cart/cart_api'
CartApi.getOrder()

document.addEventListener('turbolinks:load', () => {
  AddToCartForms.loadH4hForm()
})
